import useSWR from "swr";

type SurveyQuestions = {
  id: string;
  restaurant: string;
  question: string;
  answer_count: number;
  is_selected: boolean;
}[]

export const useFetchManlaboSurveyQuestionsByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `manzokudo_labo/restaurants/${restaurantId}/survey/questions/` : null;
  const { data: surveyQuestions, error, isLoading } = useSWR<SurveyQuestions>(fetcherKey)
  return { surveyQuestions, isLoading, error };
};
